import * as React from "react";
import SEO from "@global/Seo";
import { Store } from "@storeLocator/storeType";
import { Layout } from "@global";
import { Container, HeadingRenderer, RichTextRenderer } from "@ui";
import getStoreStatus from "@storeLocator/utils/getStoreStatus";
import { graphql } from "gatsby";
import { StoreLocatorData } from "./store-locator";
import {
  SPPhoneAddressSection,
  SPHoursSection,
  SPServicesSection,
  StoreViewButton,
} from "@storeLocator/storePage";
import generatePageMeta from "@storeLocator/utils/generatePageMeta";
import { StateElement } from "./store-locator";

const Index = ({
  pageContext,
  data,
}: {
  pageContext: { store: Store };
  data: { kontentItemStoreLocatorPage: { elements: StoreLocatorData } };
}) => {
  const { store } = pageContext;
  const { elements } = data.kontentItemStoreLocatorPage;
  const now = new Date();
  console.log(store.openingHours);
  const { status, nextAction } = getStoreStatus(store.openingHours, now);

  return (
    <Layout>
      <section className="bg-warmWhite pb-8 pt-12 font-body lg:pt-24">
        <Container className="flex flex-col items-center gap-3">
          <RichTextRenderer
            value={`<h1>${store.streetAndNumber}</h1>`}
            className="font-body text-base font-semibold not-italic tracking-wide text-darkPurple md:text-2xl lg:text-[28px] lg:tracking-[0.56px]"
          />
          <HeadingRenderer
            value={`<h2>${store.city}, ${store.province}</h2>`}
            className="font-heading text-4xl font-bold italic text-armyGreen md:text-6xl lg:text-7xl lg:leading-[110%] [&_strong]:font-extrabold"
          />
          <RichTextRenderer
            value={`<p>${status} ${nextAction}</p>`}
            className="text-lg lg:text-xl"
          />
          <StoreViewButton storeId={store.id} isMobile={true} />
          <StoreViewButton storeId={store.id} isMobile={false} />
        </Container>
      </section>
      <SPPhoneAddressSection store={store} />
      <SPHoursSection store={store} />
      <SPServicesSection
        store={store}
        stateProductInfo={elements.states.value}
      />
    </Layout>
  );
};

export default Index;

export const Head = ({
  pageContext,
  data,
}: {
  pageContext: { store: Store };
  data: { kontentItemStoreLocatorPage: { elements: StoreLocatorData } };
}) => {
  const { store } = pageContext;
  const { elements } = data.kontentItemStoreLocatorPage;
  const pageMeta = generatePageMeta(
    elements.states.value as StateElement[],
    store,
  );
  return (
    <SEO
      metadata__meta_description={{ value: pageMeta }}
      metadata__title_tag={{
        value: `easymoney ${store.city} - ${store.streetAndNumber}`,
      }}
    />
  );
};

export const query = graphql`
  query storePageQuery {
    kontentItemStoreLocatorPage {
      elements {
        global_toggle {
          value {
            codename
          }
        }
        toggle_by_state {
          value {
            codename
          }
        }
        states {
          value {
            ... on kontent_item_state_selector_state {
              elements {
                state_name {
                  value
                }
                state_abbreviation {
                  value
                }
                in_store_services {
                  value {
                    name
                  }
                }
                products {
                  value {
                    ... on kontent_item_state_selector_product {
                      elements {
                        product_name {
                          value
                        }
                        max_amount {
                          value
                        }
                        associated_page {
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
